import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { map } from "lodash";
import classnames from "classnames";
import AnimateOnVisible from "../common/animateOnVisible";
import { handleStatCalculatorOptionClick } from '../common/statistics';

const controlsList = [
  { id: 1, title: "$1000" },
  { id: 2, title: "$10,000" },
  { id: 3, title: "$30,000" }
];

const valuesList = [
  {
    id: 1,
    title: "Openbank interest earnings",
    value: [ 43, 430, 1290 ]
  },
  {
    id: 2,
    title: "Verizon + Openbank bill credit",
    value: [ 60, 120, 180 ]
  }
];

const duration = 1980;
const frameRate = 60;
const steps = duration / frameRate;

const Calc = () => {
  const [ activeIdControl, setActiveIdControl ] = useState(3);
  const initialValues = valuesList.map((item) => item.value[0]);
  const [ displayValues, setDisplayValues ] = useState(initialValues);
  const animationRef = useRef(null);
  const [ isPlateVisible, setIsPlateVisible ] = useState(false);
  const [ hasAnimatedOnce, setHasAnimatedOnce ] = useState(false);

  useLayoutEffect(() => {
    setTimeout(() => {
      setIsPlateVisible(true);
    }, 300);
  }, []);


  useEffect(() => {
    if (!isPlateVisible) {
      return;
    }

    // add delay for first time
    const delay = hasAnimatedOnce ? 0 : 1000;

    const timeoutId = setTimeout(() => {
      const startValues = [ ...displayValues ];
      const endValues = valuesList.map((item) => item.value[activeIdControl - 1]);
      let currentStep = 0;

      cancelAnimationFrame(animationRef.current);

      const animate = () => {
        currentStep++;
        const newValues = startValues.map((startVal, i) => {
          const endVal = endValues[i];
          const progress = Math.min(currentStep / steps, 1);
          return Math.floor(startVal + (endVal - startVal) * progress);
        });

        setDisplayValues(newValues);

        if (currentStep < steps) {
          animationRef.current = requestAnimationFrame(animate);
        }
      };

      animationRef.current = requestAnimationFrame(animate);
    }, delay);

    if (!hasAnimatedOnce) {
      setHasAnimatedOnce(true);
    }

    return () => {
      clearTimeout(timeoutId);
      cancelAnimationFrame(animationRef.current);
    };
  }, [ activeIdControl, isPlateVisible ]);


  const buttonClickHandle = (option) => {
    if (activeIdControl !== option.id) {
      handleStatCalculatorOptionClick(option);
    }
    setActiveIdControl(option.id);
  };


  return (
    <div className="section calc">
      <div className="container -lg">
        <AnimateOnVisible>
          <h2 className="section_title calc_title color-red">
            Watch your money grow
          </h2>
        </AnimateOnVisible>

        <AnimateOnVisible>
          <div className="calc_text">
            Each month with Verizon + Openbank Savings, earn a great return on your savings and get a bill credit on your Verizon wireless bill.
          </div>
        </AnimateOnVisible>

        <AnimateOnVisible>
          <div className="calc_plate">
            <div className="calc_plate-header">
              <h3 className="calc_plate-title">
                Estimated savings in a year*
              </h3>
            </div>

            <div className="calc_plate-content">
              <div className="calc_control-grid">
                <div className="calc_control-label">
                  Average daily balance per month
                </div>
                <div className={ classnames("calc_control-buttons", `-active-${activeIdControl}`) }>
                  <div className="calc_control-overlay" />
                  {map(controlsList, (control, index) => (
                    <button
                      key={ `ctr${index}` }
                      className={ classnames("calc_control-button", {
                        '-active': control.id === activeIdControl
                      }) }
                      onClick={ () => buttonClickHandle(control) }
                    >
                      {control.title}
                    </button>
                  ))}
                </div>
              </div>

              <div className="calc_plate-values-grid">
                {map(valuesList, (item, index) => (
                  <div className="calc_plate-values-grid-item" key={ `item${index}` }>
                    <div className="calc_plate-value">
                      <div className="calc_plate-value-label">
                        {item.title}
                      </div>
                      <div className="calc_plate-value-num color-red">
                        <span className="little-less">$</span>{displayValues[index]}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="calc_plate-footer">
                *This calculator is for illustrative purposes only. Calculated APY assumes a rate of 4.22% remaining consistent and that no withdrawals are made for one year. The Openbank high yield savings account is a variable-rate account and the rate applicable may change at any time without notice. Calculated values are based on the APY rounded to the nearest 0.01%. Estimated interest earnings are rounded down to the nearest dollar. Calculated values show interest earnings and Verizon bill credits based on an average daily balance per month.
              </div>
            </div>
          </div>
        </AnimateOnVisible>
      </div>
    </div>
  );
};

export default Calc;
